import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const ProductWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  ${props =>
    props.isLessonsLanding
      ? `background-color: ${themeGet('colors.paleGray')(props)};`
      : ''}
`
